export default {
  sections: {
    title: 'Sections',
    noContent: 'No content to list',
    seeAll: 'See all'
  }
}
